import axios from 'axios';
import apiConfig from '../../api.config';

export default function updateSftpConfig(body) {
  const {
    host,
    URIs: {updateSftpConfig},
  } = apiConfig;

  const uri = `${host}${updateSftpConfig}`;

  return axios
    .put(uri, body)
    .then(res => {
      return res.data;
    });
}
